import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  isNavigating$!: Observable<boolean>;
  isUserLoggedIn$!: Observable<boolean>;

  constructor(
    private authSerivce: AuthService
  ) {}

  ngOnInit(): void {    
    this.isUserLoggedIn$ = this.authSerivce.isUserLoggedIn$;
  }
}
